/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputSystemPermission
 */
export interface OutputSystemPermission {
    /**
     * 
     * @type {string}
     * @memberof OutputSystemPermission
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof OutputSystemPermission
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OutputSystemPermission
     */
    roles: Array<string>;
}

/**
 * Check if a given object implements the OutputSystemPermission interface.
 */
export function instanceOfOutputSystemPermission(value: object): boolean {
    if (!('description' in value)) return false;
    if (!('name' in value)) return false;
    if (!('roles' in value)) return false;
    return true;
}

export function OutputSystemPermissionFromJSON(json: any): OutputSystemPermission {
    return OutputSystemPermissionFromJSONTyped(json, false);
}

export function OutputSystemPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputSystemPermission {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'name': json['name'],
        'roles': json['roles'],
    };
}

export function OutputSystemPermissionToJSON(value?: OutputSystemPermission | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'name': value['name'],
        'roles': value['roles'],
    };
}

